export default "__VITE_ASSET__JML3Gtky__"